const getFormatted = (num) => {
    const val = String(num)
    return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export {
    getFormatted
}
